import Instagram from './code/Scripts/components/instagram.vue';

export default {
  components: {
    Instagram,
  },
};
